/**
 * Returns true only when all licences block download.
 *
 * A paid licence still allows download, even with a trial/student/school licence.
 * Empty licence lists are left for callers to handle.
 */
export function hasOnlyBlockedLicenses(licenses: { ean: string }[] | null | undefined, eanNotDownloadable: readonly string[]): boolean {
  return !!licenses?.length && licenses.every(license => eanNotDownloadable.includes(license.ean))
}
